<script lang="ts">
  import Button from "../../common/form/Button.svelte";

  export let count: number;
  export let max: number = 10000;
  export let min: number = 1;

  let value: number = count;

  function handleValueChange() {
    value = Math.min(max, Math.max(value, min));
    count = value;
  }

  function increase() {
    value += 1;
    handleValueChange();
  }
  
  function decrease() {
    value -= 1;
    handleValueChange();
  }
</script>

<div class="counter">
  <div class="btn btn-left">
    <Button color="secondary" type="button" on:click={decrease}>
      <svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0.3C0 0.134315 0.134315 0 0.3 0H7.7C7.86569 0 8 0.134315 8 0.3V1.7C8 1.86569 7.86569 2 7.7 2H0.3C0.134315 2 0 1.86569 0 1.7V0.3Z" fill="#A7B0B5"/>
      </svg>  
    </Button>
  </div>

  <input
    bind:value={value}
    on:change={handleValueChange}
    type="number"
    class="w-full h-full"
    {...$$restProps}
  />

  <div class="btn btn-right">
    <Button color="secondary" type="button" on:click={increase}>
      <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 3.3C0 3.13431 0.134315 3 0.3 3H7.7C7.86569 3 8 3.13431 8 3.3V4.7C8 4.86569 7.86569 5 7.7 5H0.3C0.134315 5 0 4.86569 0 4.7V3.3Z" fill="#A7B0B5"/>
        <path d="M4.7 -1.31134e-08C4.86569 -5.87107e-09 5 0.134315 5 0.3L5 7.7C5 7.86569 4.86569 8 4.7 8L3.3 8C3.13431 8 3 7.86569 3 7.7L3 0.3C3 0.134315 3.13431 -8.15517e-08 3.3 -7.43094e-08L4.7 -1.31134e-08Z" fill="#A7B0B5"/>
      </svg>  
    </Button>
  </div>
</div>

<style lang="postcss">
  .counter {
    @apply relative border border-solid border-light-100 rounded;
    max-width: 200px;
    height: 50px;
  }

  input {
    @apply px-7 py-1 text-center outline-none border-none;
  }

  .btn {
    @apply absolute top-1 bottom-1 w-6;
  }

  .btn :global(button) {
    @apply p-0 w-full h-full flex flex-row items-center justify-center;
  }

  .btn-left {
    @apply left-1;
  }

  .btn-right {
    @apply right-1;
  }
</style>
